import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.css';

interface NavItem {
	label: string;
	href: string;
	icon: React.ComponentType<{ size?: number }>;
}

interface NavSection {
	title: string;
	items: NavItem[];
}

interface SidebarProps {
	sections: NavSection[];
	userName?: string;
	onSignOut?: () => void;
	accountActionLabel?: string;
}

export function Sidebar({
	sections,
	userName,
	onSignOut,
	accountActionLabel = 'Sign out',
}: SidebarProps) {
	return (
		<nav className={styles.sidebar}>
			<NavLink to="/projects" className={styles.logo}>
				measurements
			</NavLink>

			<ul className={styles.navList}>
				{sections.map((section) => (
					<li key={section.title}>
						<div className={styles.navSection}>{section.title}</div>
						<ul style={{ listStyle: 'none' }}>
							{section.items.map((item) => (
								<li key={item.href}>
									<NavLink
										to={item.href}
										className={({ isActive }) =>
											[styles.navItem, isActive ? styles.navItemActive : '']
												.filter(Boolean)
												.join(' ')
										}
									>
										<item.icon size={16} />
										{item.label}
									</NavLink>
								</li>
							))}
						</ul>
					</li>
				))}
			</ul>

			<div className={styles.userArea}>
				{userName && <span className={styles.userEmail}>{userName}</span>}
				{onSignOut && (
					<button type="button" className={styles.signOut} onClick={onSignOut}>
						{accountActionLabel}
					</button>
				)}
			</div>
		</nav>
	);
}
